import utils from "utils";
import { actions } from "@ehi/global-marketing-interface";

const {
  extrasState,
  extrasUpdate: gmiExtrasUpdate,
} = actions.reservations;

export const setAllExtras = (extrasArray) => (dispatch) => {
    dispatch(extrasState.set(null, extrasArray));
    utils.dom.loadingOverlay(true);
    return dispatch(gmiExtrasUpdate()).then((res) => {
        utils.dom.loadingOverlay(false);
        return res;
    });
};